import 'tinycolor2';
import throwOnUndefinedProperty from '../../utils/throwOnUndefinedProperty/index.js';
import '../../utils/shouldShowForEnvironment/index.js';

var BREAKPOINTS = {
  xs: 330,
  sm: 576,
  md: 768,
  lg: 992,
  xl: 1200,
  xxl: 1440
};
var BREAKPOINTS$1 = throwOnUndefinedProperty(BREAKPOINTS);

export { BREAKPOINTS$1 as default };
